module.exports = __webpack_public_path__ + "static/media/IMG_3734.47f9dabc.jpg";